/**
 * Turn a link into page reloader while toggling some parameters. Use this when
 * you are having problems with caching of links. For example, when we add
 * filter A, link B must now remember that selection if it is also selected.
 * If the page is cached, then B would be using the old link and forget A.
 * Instead, specify how the link should work and let this rewrite the URL each
 * time the page loads. You should still write the link manually for any non JS
 * bots.
 *
 * Usage:
 *  <a href="#" data-url-param-toggle-name="planet" data-url-param-toggle-value="Mars" data-url-param-toggle-remove="filter,sector">
 *
 *  data-url-param-toggle-name:   Name of the parameter to set
 *  data-url-param-toggle-value:  Value of the parameter to set
 *  data-url-param-toggle-remove: Comma separated list of params to remove
 *
 * If you want a link that only removes parameters, set the
 * data-url-param-toggle-name to one of the parameter names you want removed in
 * addition to the data-url-param-toggle-remove.
 */

import $ from 'jquery';

function editURLParam(url, param, value) {
  const searchParams = url.searchParams;

  if (searchParams.get(param) === value) {
    searchParams.delete(param);
  } else {
    searchParams.set(param, value);
  }

  url.search = searchParams.toString();
  return url;
}

function removeURLParam(url, param) {
  var searchParams = url.searchParams;
  searchParams.delete(param);
  url.search = searchParams.toString();
  return url;
}

export const setupURLParamTogglers = () => {
  $('[data-url-param-toggle-name]').each((param, link) => {
    link = $(link);

    let url = new URL(document.URL);

    url = editURLParam(
      url,
      link.attr('data-url-param-toggle-name'),
      link.attr('data-url-param-toggle-value')
    );

    const removeAttrs = link.attr('data-url-param-toggle-remove');

    if (removeAttrs) {
      removeAttrs.split(',').forEach(param => {
        url = removeURLParam(url, param);
      });
    }

    link.attr('href', url.toString());
  });
};
